module.exports = __webpack_public_path__ + "static/media/categories.b6a4934b.svg";